// extracted by mini-css-extract-plugin
export var parcelRow = "_vb-0";